/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Complimentary_Account_DescriptionInputs */

const fr_admin_complimentary_account_description = /** @type {(inputs: Admin_Complimentary_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le membre ne verra pas l'invitation à choisir une formule (staff, partenaire, famille…).`)
};

/**

* @param {Admin_Complimentary_Account_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_complimentary_account_description = /** @type {((inputs?: Admin_Complimentary_Account_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Complimentary_Account_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_complimentary_account_description(inputs)
});